module.exports = __webpack_public_path__ + "img/384-a67746.png";